import { useParams } from '@xing-com/crate-core-router';

import { NotFound } from './components/not-found/not-found';
import { Page } from './components/page/page';
import { RecommendationPageType } from './config';

export const App: React.FC = () => {
  const { type } = useParams();
  const isRecommendationPage = Object.values(RecommendationPageType).includes(
    type
  );

  return isRecommendationPage ? <Page type={type} /> : <NotFound default />;
};
